import { styled } from "@mui/system";
import { useMediaQuery } from "@mui/material";
import { MaterialDesignContent, SnackbarProvider } from "notistack";
import { ReactChildren } from "../../interfaces/Common";

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent-success": {
    fontSize: "16px",
    fontWeight: "500",
  },
  "&.notistack-MuiContent-error": {
    fontSize: "16px",
    fontWeight: "500",
  },
  "&.notistack-MuiContent-default": {
    fontSize: "16px",
    fontWeight: "500",
  },
  "&.notistack-MuiContent-warning": {
    fontSize: "16px",
    fontWeight: "500",
  },
  "&.notistack-MuiContent-info": {
    fontSize: "16px",
    fontWeight: "500",
  },
}));

const AppSnackBar: React.FunctionComponent<ReactChildren> = ({ children }) => {
  // Same breakpoint AppLayout uses to decide mobile vs desktop chrome.
  const isMobile = useMediaQuery("(max-width:1000px)");

  return (
    <SnackbarProvider
      Components={{ success: StyledMaterialDesignContent, error: StyledMaterialDesignContent, info: StyledMaterialDesignContent, default: StyledMaterialDesignContent, warning: StyledMaterialDesignContent }}
      // On phones a top-anchored toast lands under the status bar / notch, because the
      // native shell draws the WebView edge-to-edge (StatusBar.overlaysWebView(true)).
      // Anchor to the bottom there instead, clear of the fixed bottom nav + home indicator.
      anchorOrigin={isMobile ? { horizontal: "center", vertical: "bottom" } : { horizontal: "center", vertical: "top" }}
    >
      {children}
    </SnackbarProvider>
  );
};

export default AppSnackBar;
